import Icon from '../components/Icon.vue'

Icon.register({"ticket-alt":{"width":576,"height":512,"paths":[{"d":"M128 160H448V352H128V160zM528 256C528 282.5 549.5 304 576 304V400C576 426.5 554.5 448 528 448H48C21.5 448 0 426.5 0 400V304C26.5 304 48 282.5 48 256S26.5 208 0 208V112C0 85.5 21.5 64 48 64H528C554.5 64 576 85.5 576 112V208C549.5 208 528 229.5 528 256zM480 152C480 138.7 469.3 128 456 128H120C106.7 128 96 138.7 96 152V360C96 373.3 106.7 384 120 384H456C469.3 384 480 373.3 480 360V152z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ticket-alt.js
// module id = mYk7
// module chunks = 0